<div class="flex flex-wrap lg:flex-nowrap gap-6">
  <div
    class="card w-full h-fit"
    [class]="shipment() != null || readOnly() ? 'lg:w-full' : 'lg:w-1/2'"
  >
    <div class="text-xl font-bold">Sobre o Cliente</div>

    @if(customer()){
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-5">
      <div>
        <div class="text-sm font-bold">Nome Completo</div>
        <div class="mt-1">
          {{ customer()!.fullName || "-" }}
        </div>
      </div>
      <div>
        <div class="text-sm font-bold">Endreço</div>
        <div class="mt-1">
          {{ order()?.shippingAddress?.street || "-" }} -
          {{ order()?.shippingAddress?.city || "-" }},
          {{ order()?.shippingAddress?.state || "-" }}
          {{ order()?.shippingAddress?.zipCode || "-" }}
        </div>
      </div>
    </div>

    } @if(shipment() != null){
    <div class="text-lg font-bold mb-3 mt-5">Dados do Envio</div>

    <div class="flex justify-between gap-6">
      <div>
        <div class="text-sm font-bold">Transportadora</div>
        <div class="mt-1">
          {{ shipment()!.carrierName || "-" }}
        </div>
      </div>

      <div>
        <div class="text-sm font-bold">Código de Rastreio</div>
        <div class="mt-1">
          @if(shipment()!.trackingCode){
          {{ shipment()!.trackingCode }}
          }@else{ - }
        </div>
      </div>

      <div>
        <div class="text-sm font-bold">Data de Envio</div>
        <div class="mt-1">
          @if(shipment()!.shippedAt){
          {{ shipment()!.shippedAt | date : "dd/MM/yyyy" }}
          }@else{ - }
        </div>
      </div>

      <div>
        <div class="text-sm font-bold">Previsão Entrega</div>
        <div class="mt-1">
          @if(shipment()!.estimatedDeliveryDate){
          {{ shipment()!.estimatedDeliveryDate | date : "dd/MM/yyyy" }}
          }@else{ - }
        </div>
      </div>
    </div>

    @if(!readOnly()){
    <div class="mt-5">
      <div class="w-1/2">
        <div class="text-sm font-bold">Status do Transporte</div>
        <p-select
          [options]="shipmentStatusOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="shipmentStatus"
          placeholder="Selecione o status do pedido"
          class="w-full"
        ></p-select>
      </div>

      <p-button
        type="button"
        label="Salvar"
        rounded
        (click)="updateShipmentStatus()"
        class="block mt-5 w-fit"
      ></p-button>
    </div>
    }
    }
  </div>
  @if(shipment() == null && !readOnly()){
  <div class="card w-full lg:w-1/2">
    <div class="text-xl font-bold">Informações do envio</div>

    <form
      [formGroup]="formGroup"
      class="mt-5 space-y-4"
      (ngSubmit)="onSubmit()"
    >
      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold"> Transportadora * </label>

        <p-select
          formControlName="carrierId"
          [options]="carriersDropdown()"
          optionLabel="label"
          optionValue="value"
          [loading]="selectLoading()"
          placeholder="Selecione"
          class="w-full"
        ></p-select>

        <app-form-error [control]="formGroup.get('carrierId')"></app-form-error>
        <app-form-server-error [control]="formGroup.get('carrierId')" />
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold"> Código de Rastreio * </label>
        <input
          pInputText
          type="text"
          formControlName="trackingCode"
          maxlength="255"
          class="w-full"
          placeholder="Informe o código de rastreio"
        />

        <app-form-error
          [control]="formGroup.get('trackingCode')"
        ></app-form-error>
        <app-form-server-error [control]="formGroup.get('trackingCode')" />
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold"> Data do envio * </label>

        <p-inputMask
          formControlName="shippedAt"
          class="w-full"
          placeholder="Informe a data de envio"
          mask="99/99/9999"
          fluid
        />

        <app-form-error [control]="formGroup.get('shippedAt')"></app-form-error>
        <app-form-server-error [control]="formGroup.get('shippedAt')" />
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold"
          >Data estimada para entrega *</label
        >

        <p-inputMask
          formControlName="estimatedDeliveryDate"
          class="w-full"
          placeholder="Informe a data estimada para entrega"
          mask="99/99/9999"
          fluid
        />

        <app-form-error
          [control]="formGroup.get('estimatedDeliveryDate')"
        ></app-form-error>
        <app-form-server-error
          [control]="formGroup.get('estimatedDeliveryDate')"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold">Anotações</label>
        <textarea
          pInputTextarea
          formControlName="note"
          rows="4"
          maxlength="255"
          class="w-full"
          placeholder="Faça uma anotação"
        ></textarea>

        <app-form-error [control]="formGroup.get('note')"></app-form-error>
        <app-form-server-error [control]="formGroup.get('note')" />
      </div>
      <div class="flex justify-end">
        <p-button
          type="button"
          label="Salvar"
          rounded
          [disabled]="formGroup.invalid"
          (click)="onSubmit()"
        ></p-button>
      </div>
    </form>
  </div>
  } @if(loading()) {
  <div
    class="absolute inset-0 z-9999 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</div>
